import React from 'react';
import PropTypes from 'prop-types';
import { DetailList } from 'common/display/DetailList';

export const VerticalDivider = () => <div className="border-l border-dark-fill-blue border-solid" />;

export const TwoPanelCardBody = ({ firstPanel, secondPanel }) => (
  <div className="flex flex-col p-6">
    <div className="flex gap-x-6">
      <div className="w-1/2">
        {firstPanel}
      </div>
      <VerticalDivider />
      <div className="w-1/2">
        {secondPanel}
      </div>
    </div>
  </div>
);

TwoPanelCardBody.propTypes = {
  firstPanel: PropTypes.node.isRequired,
  secondPanel: PropTypes.node.isRequired,
};

export const FullWidthDetailList = ({ ...props }) => <DetailList columnLayout="grid-cols-[1fr_3fr]" {...props} />;

export {
  DetailList,
};
